export default "__VITE_ASSET__DCF$AgSC__"